import { SimpleCarousel } from '@eventbrite/consumer-search.collection-carousel';
import { useIntl } from 'react-intl';
import React from 'react';
import { TopDestinations } from '@/src/homepage/types';
import { TopDestinationCard } from '../../components/TopDestinationCard';
import { useTopDestinations } from './hooks';
import styles from './TopDestinations.module.scss';

const TopDestinationsHeader = ({ countryDisplayName }: { countryDisplayName: string | null }) => {
    const intl = useIntl();
    return (
        <h2 className={styles.header}>
            {countryDisplayName
                ? intl.formatMessage(
                      {
                          id: 'Top destinations in {countryDisplayName}',
                          defaultMessage: 'Top destinations in {countryDisplayName}',
                      },
                      { countryDisplayName },
                  )
                : intl.formatMessage({
                      id: 'Top destinations',
                      defaultMessage: 'Top destinations',
                  })}
        </h2>
    );
};

export const TopDestinationsContainer = (props: {
    ebDomain: string;
    languageSubdirectory: string;
    topDestinations?: TopDestinations;
    tld: string;
}) => {
    const [countryDisplayName, topDestinations] = useTopDestinations(
        props.ebDomain,
        props.tld,
        props.topDestinations,
    );

    return (
        <div className={styles.root}>
            <SimpleCarousel
                slidesVisible={{ desktop: 4, tablet: 2 }}
                headerTitle={<TopDestinationsHeader countryDisplayName={countryDisplayName} />}
                autoWidthSlides
            >
                {topDestinations?.map(({ locationSlug, displayName, imageUrl }, index) => {
                    return (
                        <TopDestinationCard
                            key={`${locationSlug}-${index}`}
                            locationSlug={locationSlug}
                            displayName={displayName}
                            imageUrl={imageUrl}
                            languageSubdirectory={props.languageSubdirectory}
                            imageLoading={'lazy'}
                        />
                    );
                })}
            </SimpleCarousel>
        </div>
    );
};
